import styled, { css } from 'styled-components';

import SwimlaneItem from '@components/SwimlaneItem';
import { IMAGE_SIZE, IMAGE_SIZE_PERCENTAGE } from '@services/images/constants';

function calcWidth(size) {
  return `calc(100% * ${size})`;
}

const Container = styled(SwimlaneItem)`
  position: relative;
  width: ${calcWidth(IMAGE_SIZE_PERCENTAGE.MEDIUM)};
  ${props =>
    props.size === IMAGE_SIZE.BIG &&
    css`
      margin: 0 auto;
      width: ${calcWidth(IMAGE_SIZE_PERCENTAGE.BIG)};
      margin-right: 12px;
    `}
  ${props =>
    props.size === IMAGE_SIZE.SMALL &&
    css`
      width: ${calcWidth(IMAGE_SIZE_PERCENTAGE.SMALL)};
    `}
    ${props =>
      props.maxContent &&
      css`
        height: max-content;
      `}
`;

const StyledContainer = styled(Container)`
  width: 192px;
  height: 258px;
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 6)};
  padding: ${({ theme }) => theme.spacing(0, 0, 6, 0)};
  position: relative;
`;

export default Container;
export { StyledContainer };
